import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import ProjectCards from "../Cards/ProjectCards";
import { projects } from "../../data/constants";

const Projects = ({ setOpenModal }) => {
  return (
    <Box id="projects" sx={{ py: { xs: 8, md: 14 } }}>
      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" spacing={4} sx={{ mb: 10 }}>
          <Typography sx={{
            fontFamily: "'Inter', sans-serif", fontWeight: 300,
            fontSize: { xs: "2.5rem", md: "4.5rem" }, color: "#e6e8ec",
            lineHeight: 1, letterSpacing: "-0.02em",
          }}>
            EVIDENCE BOARD
          </Typography>
          <Box sx={{ flex: 1, height: 1, bgcolor: "rgba(107, 117, 130, 0.3)" }} />
        </Stack>
      </Container>
      
      {/* Horizontal Scrolling Box */}
      <Box sx={{ overflowX: "auto", overflowY: "hidden", px: { xs: 2, md: 6 }, pb: 4, display: "flex", gap: 4, "::-webkit-scrollbar": { height: 4 } }}>
        <Box sx={{ minWidth: { md: 24 } }} /> {/* Leading spacer */}
        {projects.map((p, i) => (
          <ProjectCards key={`project-${p.id || i}-${p.title || i}`} project={p} setOpenModal={setOpenModal} index={i} />
        ))}
        <Box sx={{ minWidth: { md: 24 } }} /> {/* Trailing spacer */}
      </Box>
    </Box>
  );
};

export default Projects;
